"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var support_1 = require("../functions/support");
/**
 * Mixin class for support API calls,
 * such a forgotten password.
 * @TODO Find way to pass in device id and device name.
 * @TODO Should not be using config.version, use this.version instead.
 * @TODO Device type probably should be 'management', and should be dynamic.
 */
var SupportMixin = /** @class */ (function () {
    function SupportMixin() {
    }
    /**
     * Request to resolve forgotten password.
     * @param email
     * @param captchaResponse
     * @param callback
     */
    SupportMixin.prototype.forgotPassword = function (email, captchaResponse, callback) {
        var _this = this;
        var body = {
            email: email,
            validationType: 'recaptchaV2',
            response: captchaResponse,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post('/password-reset', null, body, wrappedCallback);
    };
    /**
     * Send support ticket
     * @param from
     * @param subject
     * @param type
     * @param body
     * @param image
     * @param local BryxLocalStorage object
     * @param callback
     */
    SupportMixin.prototype.sendSupportTicket = function (from, subject, type, body, image, local, callback) {
        var _this = this;
        var sendRequest = function (imageData) {
            var attachments = [
                {
                    contentType: 'text/plain',
                    fileName: 'localStorage.txt',
                    data: (0, support_1.bryxItemsAttachment)(local),
                },
                {
                    contentType: 'text/plain',
                    fileName: 'logs.txt',
                    data: (0, support_1.logsAttachment)(local.log),
                },
                {
                    contentType: 'text/plain',
                    fileName: 'deviceInfo.txt',
                    data: (0, support_1.deviceInfoAttachment)(),
                },
            ];
            if (imageData != null) {
                attachments.push(imageData);
            }
            var requestBody = {
                body: body,
                email: from,
                subject: subject,
                type: type,
                platform: 'management',
                attachments: attachments,
            };
            var wrappedCallback = function (request, response) {
                callback(_this.apiResultFromParse(response, _this.nullParser));
            };
            _this.http.post('/support', null, requestBody, _this.unauthenticatedCallback(wrappedCallback));
        };
        if (image != null) {
            (0, support_1.readFileToAttachment)(image, function (result) {
                if (result.key == 'success') {
                    sendRequest(result.attachment);
                }
                else {
                    callback(_this.apiFailure(null, "Unable to read file: ".concat(result.message)));
                }
            });
        }
        else {
            sendRequest(null);
        }
    };
    /**
     * Reset password for accoutn vai password reset API key
     * @param token
     * @param newPassword
     * @param confirmPassword
     * @param callback
     */
    SupportMixin.prototype.resetPassword = function (token, newPassword, confirmPassword, callback) {
        var _this = this;
        var body = {
            newPassword: newPassword,
            confirmPassword: confirmPassword,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/password-reset/".concat(token), null, body, wrappedCallback);
    };
    return SupportMixin;
}());
exports.default = SupportMixin;
//# sourceMappingURL=SupportMixin.js.map